import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const ChecklistIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4 7L5.5 8.5L8 5M4 14L5.5 15.5L8 12M11 7H20M11 14H20M11 21H20M4 21H4.01"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
);

ChecklistIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(ChecklistIcon);
